<!-- <dashboardnav> -->
  <cradua-incident-tabs
    [incidentTabss]="incidentTabss$ | async"
    (incidentTabs)="onSubmitIncidentTabs($event)"
    (deleteIncidentTabsEvent)="onDeleteIncidentTabs($event)"
    *ngIf="(isLoadingIncidentTabs$ | async ) === false"
    >
  </cradua-incident-tabs>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingIncidentTabs$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
   
